import { Building2, ChevronDown } from 'lucide-react'
import { useMeta } from '@/api/queries'
import { useUiStore } from '@/stores/uiStore'
import { Menu, MenuContent, MenuLabel, MenuRadioGroup, MenuRadioItem, MenuTrigger } from '@/components/ui/Menu'

const ALL = '__all__'

/** Department scope for the next question; "All departments" by default. */
export function DepartmentSelect() {
  const meta = useMeta()
  const department = useUiStore((s) => s.department)
  const setDepartment = useUiStore((s) => s.setDepartment)
  const departments = meta.departments ?? []
  const total = departments.reduce((sum, d) => sum + (d.documents ?? 0), 0)
  const label = department ?? 'All departments'

  if (!departments.length) return <span />

  return (
    <Menu>
      <MenuTrigger asChild>
        <button
          type="button"
          aria-label={`Search scope: ${label}`}
          className="inline-flex h-8 max-w-[60vw] items-center gap-1.5 rounded-lg px-2.5 text-xs font-medium text-ink-muted transition-colors hover:bg-subtle hover:text-ink data-[state=open]:bg-subtle"
        >
          <Building2 className="size-3.5 shrink-0" aria-hidden />
          <span className="truncate">{label}</span>
          <ChevronDown className="size-3.5 shrink-0" aria-hidden />
        </button>
      </MenuTrigger>
      <MenuContent align="start" side="top" className="min-w-[14rem]">
        <MenuLabel>Search in</MenuLabel>
        <MenuRadioGroup value={department ?? ALL} onValueChange={(v) => setDepartment(v === ALL ? null : v)}>
          <MenuRadioItem value={ALL} hint={total ? `${total} docs` : undefined}>
            All departments
          </MenuRadioItem>
          {departments.map((d) => (
            <MenuRadioItem key={d.name} value={d.name} hint={`${d.documents} docs`}>
              {d.name}
            </MenuRadioItem>
          ))}
        </MenuRadioGroup>
      </MenuContent>
    </Menu>
  )
}
